import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { RefindIcon } from '../components/base/RefindIcon';
import { Button } from '../components/base/Button';
import { useTheme } from '../hooks/useTheme';
import { useAuth, useAppModals } from '../hooks';
import type { PriceId } from '../api/services';
import styles from './HeroScreen.module.css';

export const HeroScreen = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const { openAuthPrompt, openAuthPromptForCheckout } = useAppModals();

  useTheme();

  if (isAuthenticated) return null;

  const handleSubscribe = (priceId: PriceId) => {
    openAuthPromptForCheckout(priceId);
  };

  return (
    <div className={styles.hero}>
      <div className={styles.content}>
        <RefindIcon size={64} className={styles.logo} />
        <h1 className={styles.title}>{t('hero.title', 'Sua caixa de entrada para links')}</h1>
        <p className={styles.subtitle}>
          {t('hero.subtitle', 'Salve, busque e encontre seus links em qualquer lugar.')}
        </p>
        <Button
          variant="primary"
          onClick={openAuthPrompt}
          className={styles.cta}
        >
          {t('header.signIn', 'Entrar')}
        </Button>

        <section className={styles.pricing}>
          <h2 className={styles.pricingTitle}>{t('hero.pricingTitle')}</h2>
          <div className={styles.plans}>
            <div className={styles.plan}>
              <span className={styles.planName}>{t('hero.proMonthly')}</span>
              <span className={styles.planPrice}>
                {t('hero.proMonthlyPrice')}
                <span className={styles.planPeriod}>{t('hero.proMonthlyPeriod')}</span>
              </span>
              <p className={styles.planFeatures}>{t('hero.features')}</p>
              <Button variant="secondary" onClick={() => handleSubscribe('pro_monthly')} className={styles.planCta}>
                {t('hero.subscribe')}
              </Button>
            </div>
            <div className={styles.plan}>
              <span className={styles.planBadge}>{t('hero.proYearlySave')}</span>
              <span className={styles.planName}>{t('hero.proYearly')}</span>
              <span className={styles.planPrice}>
                {t('hero.proYearlyPrice')}
                <span className={styles.planPeriod}>{t('hero.proYearlyPeriod')}</span>
              </span>
              <p className={styles.planFeatures}>{t('hero.features')}</p>
              <Button variant="secondary" onClick={() => handleSubscribe('pro_yearly')} className={styles.planCta}>
                {t('hero.subscribe')}
              </Button>
            </div>
            <div className={styles.plan}>
              <span className={styles.planName}>{t('hero.lifetime')}</span>
              <span className={styles.planPrice}>{t('hero.lifetimePrice')}</span>
              <span className={styles.planOnce}>{t('hero.lifetimeOnce')}</span>
              <p className={styles.planFeatures}>{t('hero.features')}</p>
              <Button variant="secondary" onClick={() => handleSubscribe('lifetime')} className={styles.planCta}>
                {t('hero.subscribe')}
              </Button>
            </div>
          </div>
        </section>

        <nav className={styles.links}>
          <Link to="/faq" className={styles.link}>{t('drawer.faq')}</Link>
          <span className={styles.sep}>·</span>
          <Link to="/about" className={styles.link}>{t('drawer.about')}</Link>
          <span className={styles.sep}>·</span>
          <Link to="/privacy" className={styles.link}>{t('drawer.privacy')}</Link>
        </nav>
      </div>
    </div>
  );
};
